import React, { FC, PropsWithChildren } from 'react';

import { ErrorMessageBubbleIcon, ErrorMessageText } from '../../MessageBubble';
import { ErrorMessage } from '../../TextInput';

import { RadioGroupContainer } from './styles';

const kebabize = (str: string) =>
  str
    .split('')
    .map((letter: string, idx: number) =>
      letter.toUpperCase() === letter
        ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
        : letter
    )
    .join('');

interface RadioGroupProps extends PropsWithChildren {
  name: string;
  error?: string;
}

export const RadioGroup: FC<RadioGroupProps> = ({ name, error, children }) => (
  <>
    <RadioGroupContainer
      id={name}
      data-testid={`${kebabize(name)}-radio-group`}
    >
      {children}
    </RadioGroupContainer>

    {error && (
      <ErrorMessage
        id={`${name}-error-container`}
        data-testid={`${name}-error-container`}
        isVisible
      >
        <ErrorMessageText
          id={`${name}-error-text`}
          data-testid={`${name}-error-text`}
        >
          {error}
        </ErrorMessageText>
        <ErrorMessageBubbleIcon />
      </ErrorMessage>
    )}
  </>
);

RadioGroup.defaultProps = {
  error: null,
};
